import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import Utils from 'src/app/shared/fgi-utils';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_GESTOR_CONSULTA } from "../../../../constantes/permissao.constants";
import { ResultadoCalculoValorHonradoARecuperar } from '../../../../model/recuperacao-credito.model';
import { ModalidadeService } from "../../../../shared/services/modalidade.service";
import { RecuperacaoCreditoService } from '../recuperacao-credito.service';

@Component({
    selector: 'calculo-valor-honrado-recuperar',
    templateUrl: './calculo-valor-honrado-recuperar.component.html',
    styleUrls: ['./calculo-valor-honrado-recuperar.component.scss'],
    standalone: false
})
export class CalculoValorHonradoRecuperarComponent {
    public podeEscolherAgente: boolean;
    public agenteFinanceiro: AgenteFinanceiro;
    public agentesFinanceiros: AgenteFinanceiro[];
    public cnpjUsuario: string;
    public sistema: string = '';
    public idExternoOperacao: string;
    public contrato: string;
    public dataReferencia: Date;
    public resultado: ResultadoCalculoValorHonradoARecuperar;
    public nomeModalidade: string;

    constructor(private service: RecuperacaoCreditoService,
                private permissaoService: PermissaoService,
                private bnUsuarioService: BnUsuarioService,
                private activatedRoute: ActivatedRoute,
                private modalidadeService: ModalidadeService) {
    }

    ngOnInit() {
        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];

        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
          this.podeEscolherAgente = resp && resp[ROLE_GESTOR_CONSULTA];
        });
    
        this.bnUsuarioService.usuario$.subscribe(usuario => {
          this.cnpjUsuario = usuario && usuario.cnpj;
        });

        this.modalidadeService.modalidade$.subscribe((mod) => {
            for (let modalidade of this.modalidadeService.getModalidades()) {
                if (modalidade.sigla == mod) {
                  this.nomeModalidade = modalidade.nome;
                }
              }
        });
    }

    limpar() {
        this.agenteFinanceiro = undefined;
        this.sistema = '';
        this.idExternoOperacao = undefined;
        this.contrato = undefined;
        this.dataReferencia = undefined;
    }

    filtrosValidos() {
        return this.dataReferencia
            && this.sistema != ''
            && (((!this.podeEscolherAgente || this.agenteFinanceiro) && this.idExternoOperacao && this.idExternoOperacao.match(/^[A-Za-z0-9_\-]{1,20}$/)
            && this.sistema == 'CL') || (this.contrato && this.contrato.match(/^[0-9]{11}$/) && (this.sistema == '15' || this.sistema == '89')));
    }

    calcular() {
        let params: any = {};
        if (!this.podeEscolherAgente) {
            params.cnpjAgenteFinanceiro = this.cnpjUsuario;
        }
        else {
            if (this.agenteFinanceiro) {
                params.cnpjAgenteFinanceiro = this.agenteFinanceiro.cnpj.trim();
            }
        }
        if (this.sistema != '') {
            params.sistema = this.sistema;
        }
        if (this.idExternoOperacao) {
            params.idExternoOperacao = this.idExternoOperacao.trim();
        }
        if (this.contrato) {
            params.contrato = this.contrato.trim();
        }
        if (this.dataReferencia) {
            params.dataReferencia = moment(this.dataReferencia).format('YYYYMMDD');
        }

        this.resultado = undefined;

        this.service.calcularValorHonradoRecuperar(params).subscribe((resp) => {
            this.resultado = resp;
            console.log(this.resultado);
        });
    }

    compararSistema(item1: string, item2: string): boolean {

        if (item1 && item2) {
          return item1 === item2;
        }
        if (!item1 && !item2) {
          return true;
        }
        return false;
      }

      compararPorId(item1: string, item2: string): boolean {
        return Utils.compararPorId(item1, item2);
      }
}